const crunchBanner = () => {
  const alert = document.querySelector('.alert')
  const closeBtn = document.querySelector('.alert__btn')
  const alertDisplayStatus = localStorage.getItem('alert')

  if (closeBtn !== null) {
    closeBtn.addEventListener('click', () => {
      localStorage.setItem('alert', 'false')
      alert.classList.add('alert--hidden')
    })
  }

  if (alertDisplayStatus === 'false' && alert !== null) {
    alert.classList.add('alert--hidden')
  } else if (alert !== null) {
    alert.classList.add('alert--visible')
  }
}

function init() {
  crunchBanner()
}

export default init



// WEBPACK FOOTER //
// ./frontend/resources/assets/js/components/ui/global/crunchBanner.js